export default __webpack_public_path__ + "src/assets/icn-status-badge-declined.88cd6ac2e880017fba5a5af30de76308.svg";